import React from 'react'
import classNames from 'classnames'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { VidyardPlayButtonProps } from './VidyardPlayButton.d'

const VidyardPlayButton = ({
  label,
  onClick,
  variation = 'orange',
  interactionId = '',
  size = null,
  classes = '',
  tabIndex = 0,
  fontWeight = ['font-semibold']
}: VidyardPlayButtonProps) => {
  const pageContext = usePageContext()
  const renderIcon = () => {
    if (variation === 'orange') {
      return (
        <svg
          aria-hidden='true'
          width='107px'
          height='107px'
          viewBox='0 0 107 107'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g transform='translate(-894.000000, -2155.000000)' fill='#FFFFFF'>
              <g transform='translate(894.000000, 2155.000000)'>
                <path
                  d='M53.5,107 C23.9527659,107 0,83.0472341 0,53.5 C0,23.9527659 23.9527659,0 53.5,0 C83.0472341,0 107,23.9527659 107,53.5 C107,83.0472341 83.0472341,107 53.5,107 Z M69.9528507,56.6631817 C70.2259012,56.4969754 70.4551353,56.2677413 70.6213416,55.9946908 C71.1956634,55.0511717 70.8963698,53.8207186 69.9528507,53.2463968 L47.0204765,39.2874195 C46.7071432,39.0966929 46.3473915,38.9958119 45.980575,38.9958119 C44.8760055,38.9958119 43.980575,39.8912424 43.980575,40.9958119 L43.980575,68.9137666 C43.980575,69.2805831 44.081456,69.6403348 44.2721825,69.9536681 C44.8465043,70.8971872 46.0769574,71.1964808 47.0204765,70.622159 L69.9528507,56.6631817 Z'
                  className='animate-play-button-pulse origin-center scale-0'
                />
                <circle
                  cx='53'
                  cy='53'
                  r='20'
                  stroke='black'
                  strokeWidth='0'
                  fill='#FF4C00'
                />
                <path
                  d='M53.5,92 C32.2370371,92 15,74.7629629 15,53.5 C15,32.2370371 32.2370371,15 53.5,15 C74.7629629,15 92,32.2370371 92,53.5 C92,74.7629629 74.7629629,92 53.5,92 Z M69.5395162,56.2082474 C69.8125666,56.0420411 70.0418007,55.812807 70.2080071,55.5397565 C70.7823288,54.5962374 70.4830353,53.3657843 69.5395162,52.7914625 L46.5399016,38.7915558 C46.2265682,38.6008293 45.8668166,38.4999483 45.5,38.4999483 C44.3954305,38.4999483 43.5,39.3953788 43.5,40.4999483 L43.5,68.4997616 C43.5,68.8665782 43.600881,69.2263299 43.7916075,69.5396632 C44.3659293,70.4831823 45.5963825,70.7824758 46.5399016,70.2081541 L69.5395162,56.2082474 Z'
                  className='animate-play-button-pulse-2 origin-center'
                />
              </g>
            </g>
          </g>
        </svg>
      )
    }

    if (
      variation === 'blue' ||
      variation === 'secondary' ||
      variation === 'inverse-primary'
    ) {
      return (
        <img src={resolvePrefix('/svg/icon-play-button-blue.svg')} alt='Play' />
      )
    }

    if (variation === 'blue-primary') {
      return (
        <img
          alt='Play'
          src={resolvePrefix('/svg/icon-play-button-white.svg')}
        />
      )
    }
  }
  const btnClasses = classNames(
    classes,
    fontWeight.join(' '),
    'cursor-pointer',
    {
      'border-2 border-blue-75 border-solid px-4 py-2 mr-4 rounded-[60px]':
        variation === 'blue',
      'bg-blue-75 text-white rounded-[60px] inline-flex flex-row items-center justify-center mr-4 hover:bg-blue-100 hover:border-blue-100':
        variation === 'blue-primary',
      'border-2 border-blue-75 border-solid rounded-[60px]':
        variation === 'secondary',
      'bg-white text-blue-75 rounded-[60px] inline-flex flex-row items-center justify-center mr-4 hover:bg-blue-100 hover:border-blue-100':
        variation === 'inverse-primary',
      'py-3 px-6': size === 'default',
      'h-14 py-5 px-10 md:h-10 md:py-3 md:px-6': size === 'small',
      'py-5 px-10 md:py-4 md:px-8': size === 'medium', // remove the height to accommodate safari 13.1
      'h-14 py-5 px-10': size === 'large'
    }
  )
  if (pageContext.styleContext === 'hpVariant') {
    return (
      <div className='absolute flex flex-col justify-center items-center z-[1]'>
        <h4 className='mb-4 text-center text-white text-shadow-lg mx-[55px] flex lg:hidden'>
          134,000* locations like yours trust Toast
        </h4>
        <button
          className={btnClasses}
          data-testid='VidyardPlayButton'
          data-interaction={interactionId}
          onClick={onClick}
          tabIndex={tabIndex}
        >
          {renderIcon()}
          <span className='hidden'>{label ? label : 'Play'}</span>
          {variation === 'orange' && label ? <span>{label}</span> : ''}
          {(variation === 'blue-primary' || variation === 'inverse-primary') &&
          label ? (
            <span className='px-2'>{label}</span>
          ) : (
            ''
          )}
        </button>
        {variation === 'blue' && label ? (
          <p className='flex items-center text-secondary'>{label}</p>
        ) : (
          ''
        )}
      </div>
    )
  } else {
    return (
      <>
        <button
          className={btnClasses}
          data-testid='VidyardPlayButton'
          data-interaction={interactionId}
          onClick={onClick}
          tabIndex={tabIndex}
        >
          {renderIcon()}
          <span className='hidden'>{label ? label : 'Play'}</span>
          {variation === 'orange' && label ? <span>{label}</span> : ''}
          {(variation === 'blue-primary' || variation === 'inverse-primary') &&
          label ? (
            <span className='px-2'>{label}</span>
          ) : (
            ''
          )}
        </button>
        {variation === 'blue' && label ? (
          <p className='flex items-center text-secondary'>{label}</p>
        ) : (
          ''
        )}
      </>
    )
  }
}

export default VidyardPlayButton
